<template src='./form-action.html'></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import FormValidation from '../form-validation/FormValidation'

export default {
  components: {
    'form-validation': FormValidation
  },
  props: ['formChanged', 'formCode', 'markdownElements', 'editor', 'hasRevisions', 'canAddAdditionalComments', 'canEditProject', 'canUnlockProject', 'revisionValidation', 'revisionSelected', 'revisions'],
  data () {
    return {
      projectCode: this.$route.params.projectCode,
      projectPhaseId: this.$route.params.projectPhaseId,
      phaseFormId: this.$route.params.phaseFormId,
      submitDialog: false,
      loader: false,
      revisionErrors: [],
      revisionWarnings: [],
      projectForm: null,
      FormInputAction: {
        SAVE: 1,
        LOCK: 2,
        UNLOCK: 3
      },
      FormInputStatus: {
        UNLOCKED: 1,
        LOCKED: 2,
        MARKED: 3,
        APPROVED: 4
      }
    }
  },
  watch: {
    revisionValidation (revisionValidation) {
      this.revisionErrors = revisionValidation ? JSON.parse(revisionValidation).Errors : []
      this.revisionWarnings = revisionValidation ? JSON.parse(revisionValidation).Warnings : []
    }
  },
  methods: {
    submitFormInput (action) {
      const values = this.editor.getValue()
      // for (var i = 0; i < this.markdownElements.length; i++) {
      //   values[this.markdownElements[i].name] = this.editor.getEditor(this.markdownElements[i].editor).simplemde_instance.value()
      // }
      this.projectForm = {
        projectCode: this.projectCode,
        projectPhaseId: this.projectPhaseId,
        id: this.phaseFormId,
        formCode: this.formCode,
        json: JSON.stringify(values),
        action: action
      }
      if (action === this.FormInputAction.LOCK && this.revisionErrors.length > 0) {
        EventBus.$emit('alert', {
          variant: 'error',
          message: this.$t('projects.submitProjectFormInputError'),
          errors: []
        })
        return
      }
      if (action === this.FormInputAction.LOCK && this.revisionWarnings.length > 0) {
        this.submitDialog = true
        return
      }
      this.submitForm(action)
    },
    submitForm (action) {
      this.loader = true
      this.$http.post(Vue.$apiConfig.projectInputFormPost, this.projectForm)
        .then(
          response => {
            var additionalInformation = response.body.additionalInformation
            if (action === this.FormInputAction.SAVE && additionalInformation && additionalInformation.formNotChanged) {
              EventBus.$emit('alert', {
                variant: 'warning',
                message: this.$t('projects.submitProjectFormInputWarning'),
                errors: []
              })
            } else {
              const existingErrors = additionalInformation && additionalInformation.errors && additionalInformation.errors.length > 0
              const existingWarnings = additionalInformation && additionalInformation.warnings && additionalInformation.warnings.length > 0
              var message = this.$t('projects.submitProjectFormInputSuccessful')
              if (action === this.FormInputAction.SAVE) {
                if (existingErrors && existingWarnings) {
                  message = this.$t('projects.submitProjectFormInputSuccessfulWithErrorsAndWarnings')
                } else if (existingErrors) {
                  message = this.$t('projects.submitProjectFormInputSuccessfulWithErrors')
                } else if (existingWarnings) {
                  message = this.$t('projects.submitProjectFormInputSuccessfulWithWarnings')
                }
              }

              EventBus.$emit('alert', {
                variant: 'success',
                message: message,
                errors: []
              })
            }
            EventBus.$emit('setupPage')
            this.loader = false
            this.submitDialog = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loader = false
            this.submitDialog = false
          }
        )
    }
  },
  computed: {
    isLastRevisionSelected () {
      if (!this.revisions.length) return true
      return this.revisions[0].revision === this.revisionSelected.revision
    },
    hasErrors () {
      if (this.revisionErrors.length > 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
  .width-40 {
    width: 40%;
  }
</style>
